const palette = {
    lighterGrey: '#F5F5F5',
    lightGrey: '#E0E0E0',
    grey: '#D0D0D0',
    darkGrey: '#6E6E6E',
    darkerGrey: '#2E2E2E',
    white: '#FFF',
    blue: '#A7D3F6',
    lightBlue: '#BEE0F9',
    brightBlue: '#5DA9E9',
    green: '#2D6E38',
    red: '#E94F37',
};

export const colors = {
    ...palette,

    primary: palette.green,
    secondary: palette.blue,
    accent: palette.brightBlue,
    warning: palette.red,
    success: palette.green,

    background: palette.lightBlue,
    backgroundLoading: palette.lighterGrey,
    backgroundLight: palette.white,

    primaryText: palette.darkerGrey,
    primaryTextLight: palette.white,
    secondaryText: palette.darkGrey,

    primaryButtonText: palette.white,
    primaryButtonBackground: palette.green,
    secondaryButtonText: palette.darkerGrey,
    secondaryButtonBackground: palette.white,

    borderColor: palette.darkerGrey,
};
